import { render, staticRenderFns } from "./uom.vue?vue&type=template&id=550b813b"
import script from "./uom.vue?vue&type=script&lang=js"
export * from "./uom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports